import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const initialState: { value: number } = { value: 0 }

const guestConnectedSlice = createSlice({
  name: "guest_connected_slice",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<number>) => {
      state.value = action.payload
    }
  }
})

export const { set } = guestConnectedSlice.actions

export const guest_connected_slice = guestConnectedSlice.reducer